class SectionTestimonial extends HTMLElement {

  constructor() {
    super();

    var wrapper = this.querySelector('.testimonial-wrapper'),
      self = this;
    this.flkty = new Flickity(wrapper, {
      // options
      cellAlign: 'left',
      contain: true,
      cellSelector: '.testimonial-item',
      prevNextButtons: false,
      pageDots: false,
    });

    this.previousButton = this.querySelector('button.previous');
    this.nextButton = this.querySelector('button.next');

    function update() {
      if (self.flkty.selectedIndex <= 0) {
        self.previousButton.classList.add('inactive');
      }
      else {
        self.previousButton.classList.remove('inactive');
      }
      if (self.flkty.selectedIndex >= self.flkty.cells.length - 2) {
        self.nextButton.classList.add('inactive');
      }
      else {
        self.nextButton.classList.remove('inactive');
      }
    }

    this.previousButton.addEventListener('click', function () {
      self.flkty.previous();
      update();
    });

    this.nextButton.addEventListener('click', function () {
      self.flkty.next();
      update();
    });

    update();
  }
}

customElements.define('section-testimonial', SectionTestimonial);